"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossibleDiscountSchema = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
const numbers_1 = require("../numbers");
exports.impossibleDiscountSchema = zod_1.z.object({
    name: constants_1.defaultString,
    rawName: constants_1.defaultString,
    discountCents: zod_1.z.nullable(zod_1.z.number().min(1).max((0, numbers_1.thousand)(500))).optional(),
}).strict();
